import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Grid, Card, CardMedia, CardContent, Typography,
  Button, Box, Container
} from '@mui/material';
import useCoreApi from '../Utils/useCoreApi';
const SUBJECTS = [
  { id: 1, name: "Maths", image: "https://websitecontent.ams3.cdn.digitaloceanspaces.com/maths.avif" },
  { id: 2, name: "Science", image: "https://websitecontent.ams3.cdn.digitaloceanspaces.com/science.avif" },
  { id: 3, name: "Geography", image: "https://websitecontent.ams3.cdn.digitaloceanspaces.com/geography.avif" },
  { id: 4, name: "History", image: "https://websitecontent.ams3.cdn.digitaloceanspaces.com/history.avif" },
  { id: 5, name: "English", image: "https://websitecontent.ams3.cdn.digitaloceanspaces.com/english.avif" },
  { id: 6, name: "ICT", image: "https://websitecontent.ams3.cdn.digitaloceanspaces.com/ICT.avif" },
  { id: 7, name: "Business Studies", image: "https://websitecontent.ams3.cdn.digitaloceanspaces.com/219.jpg" },
];

const Assessments = () => {
  const navigate = useNavigate();
  const coreApi = useCoreApi();
  const [userLevels, setUserLevels] = useState({});

  useEffect(() => {
    const userId = localStorage.getItem('user_id');
    coreApi.get(`/assess/getSuggestedLevels/${userId}`)
      .then((response) => {
        setUserLevels(response.data); // { subject_id: year_level, ... }
      })
      .catch((error) => {
        console.error("Error fetching suggested levels:", error);
      });
  }, []);

  const handleStartAssessment = async (subjectId) => {
    const userId = localStorage.getItem('user_id');
    const startYear = userLevels[subjectId] || 3;

    // Save these in sessionStorage for AssessmentQuestions to use
    sessionStorage.setItem('selected_subject_id', subjectId);
    sessionStorage.setItem('start_year', startYear);

    navigate(`/assessment-questions/${subjectId}`);
  };

  const handleViewHistory = (subjectId) => {
    navigate(`/assessment-history/${subjectId}`);
  };

  const renderAssessmentCards = () => (
    <Grid container spacing={4} justifyContent="center">
      {SUBJECTS.map((subject) => (
        <Grid item key={subject.id} xs={12} sm={6} md={4}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardMedia component="img" height="140" image={subject.image} />
            <CardContent>
              <Typography gutterBottom variant="h5">
                {subject.name} Assessment
              </Typography>
              <Typography variant="body2">
                Estimated best start year: {userLevels[subject.id] || "Take an assessment to find out"}
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Button variant="contained" onClick={() => handleStartAssessment(subject.id)}>
                  Begin
                </Button>
                <Button variant="outlined" onClick={() => handleViewHistory(subject.id)}>
                  View History
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 3, mb: 5 }}>
        <Typography variant="h5" align="center" color="text.secondary" paragraph>
          Select a Subject to Start Assessment
        </Typography>
        <Typography variant="h6" align="center" color="text.secondary" paragraph>
          These assessments will help to give you a rough idea of which year to start studying for each subject available.
        </Typography>
        {renderAssessmentCards()}
      </Box>
    </Container>
  );
};

export default Assessments;
